import logger, { LEVEL_ERROR } from "./logger";

/** @deprecated use #logE */
export const logError = (message: string, ...args: any[]) => {
  logger.log(undefined, LEVEL_ERROR, message, args);
};

export const logE = (tag: string, message: string, ...args: any[]) => {
  logger.log(tag, LEVEL_ERROR, message, args);
};
